import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListSharedListPayload } from '@app-store/slices/sharedLists/list'

interface TaskAction extends Action {
    payload: IListSharedListPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.sharedLists.list

function* listSharedListSagaTask({ payload }) {
    const params = yield getParams(payload)

    try {
        const response = yield axios.get(`/companies/shared-lists`, {
            params
        })
        if (response.success) {
            yield put(onSuccess({ noSaveInStore: payload.noSaveInStore, ...response.result }))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        if (payload?.sagaCB?.onFailure) payload.sagaCB.onError(error)
    }
}

function* listSharedListSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listSharedListSagaTask)
}

export default listSharedListSaga
